var app = app || {};
(function ($) {
  $(document).ready(
    function () {
      app.main.init();
      $(window).resize(
        function (e) {
          $(document).trigger('app:viewUpdate');
        }
      );
    }
  );
  $(window).on('load', function () {
    $(document).trigger('app:load');
  });



  app.main = new function () {
    this.desktopWidth = 1279;
    this.tabletLandscapeWidth = 1024;
    this.tabletWidth = 768;
    this.mobileWidth = 480;
    this.ios = false;
    this.scrollbarWidth = 10;

    this.init = function () {
      //if window size changes from one device to another, reload the whole page
      app.core.reloadScreenSize();
      app.core.responsiveMove();
      app.core.initGaClickTrack();
      app.core.responsiveTable();



      $(document).on('app:contentLoaded.init', function () {
        app.core.responsiveMove();

      });


      app.main.initTrackingCookieNotice();

      app.main.initTrackingCookieNotice();
      app.main.initExternalLink();
      app.main.initScroll();
      app.main.fixAccessibilityIssues();

      app.aria.tabIndex.enableVisible($('body'));

    };

    this.fixAccessibilityIssues = function () {

      //fix video poster with no alt tag
      $('video img').each(function () {
        if (typeof $(this).attr('alt') === 'undefined') {
          $(this).attr('alt', '');
        }
      });
    };

    this.initScroll = function () {
      $(document).on('click', '.js-scrolldown', function () {
        var $container = $(this).parents('.js-scrolldown-container');
        if ($container.length) {
          console.log($container.offset().top, $container.height());
          app.core.smoothScroll({
            position: $container.offset().top + $container.height() - $('.nav').height()
          })
        }
      });

    };

    this.initExternalLink = function () {
      $('a').filter(function () {
        return this.hostname && this.hostname !== location.hostname;
      }).addClass("external-url").attr('target', '_blank');
    };
    this.initTrackingCookieNotice = function () {
      if (app.core.readCookie('agree_to_tracking') != 'yes') {
        $('.cookie-notice').attr('aria-hidden', 'false');
        app.aria.tabIndex.enableVisible($('body'));
      }
      $('.js-cookie-agree').on('click.initTrackingCookieNotice', function () {
        app.core.createCookie('agree_to_tracking', 'yes', 365);
        $('.cookie-notice').attr('aria-hidden', 'true');
        app.aria.tabIndex.enableVisible($('body'));
      });
    };






    this.isTablet = function () {

      if (typeof window.matchMedia == 'function') {

        if (window.matchMedia('(max-width: ' + (this.desktopWidth - 1) + 'px ) AND (min-width: ' + (this.tabletWidth) + 'px )').matches) {

          return true;
        }
      }
      else {
        if ($(window).width() < (this.desktopWidth - 15) && $(window).width() >= this.tabletWidth) {
          return true;
        }
      }

      return false;
    };
    this.isTabletPortrait = function () {

      if (typeof window.matchMedia == 'function') {

        if (window.matchMedia('(max-width: ' + (this.tabletLandscapeWidth - 1) + 'px ) AND (min-width: ' + (this.tabletWidth) + 'px )').matches) {

          return true;
        }
      }
      else {
        if ($(window).width() < (this.tabletLandscapeWidth - 15) && $(window).width() >= this.tabletWidth) {
          return true;
        }
      }

      return false;
    };
    this.isDesktop = function () {

      if (typeof window.matchMedia == 'function') {
        if (window.matchMedia('(min-width: ' + this.desktopWidth + 'px)').matches) {

          return true;
        }
      }
      else {
        if ($(window).width() >= this.desktopWidth) {
          return true;
        }
      }


      return false;
    };
    this.isMobile = function () {
      if (typeof window.matchMedia == 'function') {
        if (window.matchMedia('(max-width: ' + (this.tabletWidth - 1) + 'px)').matches) {

          return true;
        }
      }
      else {


        if ($(window).width() < this.tabletWidth) {
          return true;
        }
      }
      return false;
    };





  };


})(jQuery);
